import { createReducer, on } from '@ngrx/store';
import { GetLiteralsSuccess } from '../actions/literals.actions';

export interface LiteralsState {
  literals: any;
}

const initialState: LiteralsState = {
  literals: {},
};

export const LiteralsReducer = createReducer(
  initialState,
  on(GetLiteralsSuccess, (state, { literals }) => ({
    ...state,
    literals,
  })),
);
